import { SelectC } from 'components'
import { useState } from 'react'
import { useDebounce } from 'utils'
import { useLoadOrderBusinessUnities } from 'modules/orders/hooks'

export const SelectBusinessUnity = () => {
  const [search, setSearch] = useState<string>('')
  const searchDebounced = useDebounce(search, 250)

  const { data, isLoading } = useLoadOrderBusinessUnities({
    page: 1,
    limit: 100,
    search: searchDebounced,
    filters: {}
  })

  const handleChangeCustomer = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearch(value)
  }

  return (
    <SelectC
      name="businessUnity"
      label="Unidade de Negócio"
      options={data?.data}
      onInputChange={(e, value, reason) => handleChangeCustomer(value, reason)}
      getOptionLabel={(option: any) => option?.id + ' - ' + option?.name}
      loading={isLoading}
    />
  )
}
